import React, { useState } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { useIntl } from "gatsby-plugin-intl"
import Recaptcha from "react-google-recaptcha"
import { serialize } from "dom-form-serializer"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const RECAPTCHA_KEY = "6LfEKQUaAAAAAKlCgCyCqhQht1w5UFY0eH6WdFRa"

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

const Contact = () => {
  const intl = useIntl()

  const [alertMessage, setAlertMessage] = useState("")

  const ref = React.createRef("recaptcha")

  const data = useStaticQuery(graphql`
    query {
      email: file(relativePath: { eq: "contact-email.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      phone: file(relativePath: { eq: "contact-phone.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      map: file(relativePath: { eq: "contact-map.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  const handleSubmit = event => {
    event.preventDefault()
    const form = event.target
    const data = serialize(form)

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": form.getAttribute("name"),
        ...data,
      }),
    })
      .then(res => {
        if (res.ok) {
          return res
        } else {
          throw new Error("Network error")
        }
      })
      .then(() => {
        form.reset()
        setAlertMessage(
          intl.formatMessage({ id: "CONTACT.NOTIFICATION_MESSAGE_SENT" })
        )
      })
      .catch(err => {
        console.error(err)
        setAlertMessage(
          intl.formatMessage({ id: "CONTACT.NOTIFICATION_MESSAGE_SENT_ERROR" })
        )
      })
  }

  return (
    <Layout>
      <SEO title="Contact" />
      <div className="f-contact">
        <div className="f-contact__cover">
          <h1>{intl.formatMessage({ id: "CONTACT.TITLE" })}</h1>
        </div>

        <div className="f-contact__address">
          <div className="grid-pictures">
            <div className="grid-pictures__item"></div>
            <div className="grid-pictures__item"></div>
            <div className="grid-pictures__item"></div>
          </div>
          <div className="address">
            <div className="logo-map"></div>
            <h3>{intl.formatMessage({ id: "CONTACT.ADDRESS_TITLE" })}</h3>
            <b style={{fontStyle: 'italic'}}>{intl.formatMessage({ id: "CONTACT.ADDRESS_STREET" })}</b>
            <b>{intl.formatMessage({ id: "CONTACT.ADDRESS_CITY" })}</b>
            <p>{intl.formatMessage({ id: "CONTACT.ADDRESS_LOCATION_1" })}</p>
            <p>{intl.formatMessage({ id: "CONTACT.ADDRESS_LOCATION_2" })}</p>
          </div>

          <div style={{ width: "100%" }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d41990.426023089196!2d2.275300266481217!3d48.8696197396134!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66fc3c52c6deb%3A0x9eda90a43280f6b0!2s66%20Av.%20des%20Champs-%C3%89lys%C3%A9es%2C%2075008%20Paris%2C%20France!5e0!3m2!1sfr!2suk!4v1607807936263!5m2!1sfr!2suk"
              height="350"
              frameBorder="0"
              style={{ width: "100%", border: "0" }}
              allowFullScreen
              aria-hidden="false"
              title="map"
            ></iframe>
          </div>
        </div>

        <div className="f-contact__contact">
          <div>
            <Img
              fluid={data.phone.childImageSharp.fluid}
              style={{ width: "50px" }}
            />
            <b>{intl.formatMessage({ id: "CONTACT.TEL" })}</b>
          </div>
          <div>
            <b>{intl.formatMessage({ id: "CONTACT.EMAIL" })}</b>

            <Img
              fluid={data.email.childImageSharp.fluid}
              style={{ width: "50px" }}
            />
          </div>
        </div>

        <form
          className="f-contact__form"
          id="contact"
          name="contact"
          method="post"
          onSubmit={handleSubmit}
          action="/"
          data-netlify-recaptcha="true"
          netlify="true"
        >
          <div className="form">
            <noscript>
              <p>This form won’t work with Javascript disabled</p>
            </noscript>
            {alertMessage && <div className="Form--Alert">{alertMessage}</div>}
            <div>
              <label htmlFor="email">
                {intl.formatMessage({ id: "CONTACT.LABEL_EMAIL" })}
              </label>
              <input type="email" name="email" id="email" required />
            </div>
            <div>
              <label htmlFor="message">
                {intl.formatMessage({ id: "CONTACT.LABEL_MESSAGE" })}
              </label>
              <textarea name="message" id="message" rows="6" />
            </div>
          </div>
          <div className="actions">
            <div data-netlify-recaptcha="true"></div>
            <Recaptcha ref={ref} sitekey={RECAPTCHA_KEY} />
            <button>{intl.formatMessage({ id: "CONTACT.BUTTON_SEND" })}</button>
          </div>
        </form>
      </div>
    </Layout>
  )
}

export default Contact
